import { gql } from '@apollo/client';

export const CAN_ACTIVATE_SUBSCRIPTION_QUERY = gql`
    query canActivateSubscription($deviceName: String!) {
        canActivateSubscription(deviceName: $deviceName)
    }
`;

export const ACTIVATE_SUBSCRIPTION_MUTATION = gql`
    mutation activateSubscription($deviceName: String!) {
        activateSubscription(deviceName: $deviceName) {
            success
        }
    }
`;

const DEVICE_FEATURES_FIELDS_FRAGMENT = gql`
    fragment SwarmFeaturesFields on SwarmFeatures {
        deviceName
        swarmType
        validSubscription
        canActivateSubscription
        unavailableFeatures {
            field
            option
            showBanner
        }
    }
`;

export const DEVICE_FEATURES_QUERY = gql`
    query featureCheckSwarm($deviceName: String!) {
        featureCheckSwarm(deviceName: $deviceName) {
            ...SwarmFeaturesFields
        }
    }
    ${DEVICE_FEATURES_FIELDS_FRAGMENT}
`;

export const PROJECT_FEATURES_QUERY = gql`
    query featureCheckProject($projectId: ID!) {
        featureCheckProject(projectId: $projectId) {
            ...SwarmFeaturesFields
        }
    }
    ${DEVICE_FEATURES_FIELDS_FRAGMENT}
`;
